import cuid from 'cuid';
import { Action } from 'redux';
import { groupByActionTypes } from 'redux-undo'

export const batchGroupBy = {
  _group: null as string | null,
  start(group = cuid()) {
    this._group = group
  },
  end() {
    this._group = null
  },
  batchGroupWrapper(functionToWrap: () => void) {
    this.start();
    functionToWrap();
    this.end();
  },
  initGroupByFunction(rawActions: string[]) {
    const defaultGroupBy = groupByActionTypes(rawActions)
    return (action: Action, currentState: any, previousHistory: any) => this._group
      ?? defaultGroupBy(action, currentState, previousHistory)
  }
};